import { Box, FormControl, TextField, Autocomplete, InputAdornment } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { memo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createInventoryStatus, editInventoryStatus } from 'redux/actions/inventoryStatus/inventoryStatusActions'
import { setSnackbar } from "redux/actions/search/searchActions";

export const FormInventoryStatus = memo((props) => {
    const { handleClose, data, isEdit } = props
    const { reasonsOptions } = useSelector(({ inventoryStatus }) => inventoryStatus);
    const { date, station, unitType } = useSelector(({ inventoryStatus }) => inventoryStatus)
    const { inputValues, handleNewValues } = useForm({
        percentage: '',
        reason: null,
        reasonEdit: null,
        reasonsMapCreate: [],
        reasonsMapEdit: []
    })
    const { 
        percentage, 
        reason, 
        reasonEdit,
        reasonsMapCreate,
        reasonsMapEdit,
    } = inputValues
    const dispatch = useDispatch()
    const handlePercentageChange = useCallback(({ target }) => {
        const { value } = target;
        if (!/^\d*\.?\d{0,2}$/.test(value)) return;
        if (Number(value) > 100) return;
        handleNewValues({ percentage: value });
    }, [handleNewValues]);
    const handleSubmit = useCallback(() => {
        const percentageValue = parseFloat(percentage);
        if (Number.isNaN(percentageValue) || percentageValue < 0 || percentageValue > 100) dispatch(setSnackbar("El porcentaje es requerido y debe estar entre 0 y 100"))
        else if (isEdit ? !reasonEdit?.id : !reason?.id) dispatch(setSnackbar("La razón es requerida"))
        else {
            if (!isEdit) {
                const newValues = {
                    idUnit: data?.idUnit,
                    idInventoryReason: reason?.id,
                    idTank: data?.idTank,
                    percentage: percentageValue
                }
                dispatch(createInventoryStatus(newValues, station?.id, date, unitType, handleClose))
            } else {
                const newValues = {
                    id: data?.id,
                    idUnit: data?.idUnit,
                    changes: {
                        percentage: percentageValue,
                        idInventoryReason: reason?.id,
                    },
                    idInventoryReason: reasonEdit?.id
                }
                dispatch(editInventoryStatus(newValues, station?.id, date, unitType, handleClose))
            }
        }
    }, [reason, reasonEdit, percentage, data, station, date, unitType, handleClose])

    useEffect(() => {
        if(!reasonsMapCreate?.length){
            handleNewValues({ reasonsMapCreate: reasonsOptions.filter(r => r.application === "CREATE") })
        }
        if(!reasonsMapEdit?.length){
            handleNewValues({ reasonsMapEdit: reasonsOptions.filter(r => r.application === "EDIT") })
        }
        if (data?.percentage != null) handleNewValues({ percentage: String(data.percentage) })

        if (data?.idInventoryReason && reasonsOptions.length) {
            const reasonFound = reasonsOptions.find(rsn => rsn.id === data.idInventoryReason)
            if (reasonFound) handleNewValues({
                reason: reasonFound,
            })
        }
    }, [data, reasonsOptions])

    return (
        <>
            <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
                <TextField
                    type="text"
                    label="Porcentaje *"
                    name="percentage"
                    value={percentage}
                    onChange={handlePercentageChange}
                    variant="outlined"
                    InputProps={{
                        inputProps: { inputMode: "decimal" },
                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                    }}
                />
                {!isEdit ? (
                    <Autocomplete
                        id="combo-box-demo-2"
                        options={reasonsMapCreate}
                        value={reason}
                        filterSelectedOptions
                        getOptionLabel={(option) => option.label ? option.label : option.name}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="reason"
                                label={"Razón de Creación *"}
                                variant="outlined"
                            />
                        )}
                        fullWidth
                        onChange={(_e, v) => handleNewValues({
                            reason: v
                        })}
                        noOptionsText="No se encuentran razones"
                    />
                ) : null}
                {isEdit ? (
                    <Autocomplete
                        id="combo-box-demo-3"
                        options={reasonsMapEdit}
                        value={reasonEdit}
                        filterSelectedOptions
                        getOptionLabel={(option) => option.label ? option.label : option.name}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="reasonEdit"
                                label={"Razón de Edición *"}
                                variant="outlined"
                            />
                        )}
                        fullWidth
                        onChange={(_e, v) => handleNewValues({
                            reasonEdit: v
                        })}
                        noOptionsText="No se encuentran razones"
                    />
                ) : null}
                <Box sx={{ display: 'flex',  justifyContent: "flex-end", marginTop: 30 }}>
                    <RegularButton
                        variant="contained"
                        color="danger"
                        onClick={handleClose}
                    >
                        Cancelar
                    </RegularButton>
                    <RegularButton
                        variant="contained"
                        color={"info"}
                        onClick={handleSubmit}
                    >
                        Agregar
                    </RegularButton>
                </Box>
            </FormControl>
        </>
    )
})